import config from "assets/config";
import React, { useEffect, useRef } from "react";
import { useCallback } from "react";
import { useCookies } from "react-cookie";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import LoginService from "services/login";
import { LOGIN } from "store/actions/type/login";
import { getUserRole, logout } from "utils/common";
import { lStorage } from "utils/storage";
import { toaster } from "utils/toaster";

function HFNauth(props) {
  const apiCallCount = useRef(0);
  const ls = new LoginService();
  let history = useHistory();
  const [cookies, setCookie] = useCookies(["tourRequired", "tourGuidance"]);
  const handleAuth = useCallback((status) => {
    import("hfnauth/main").then(() => {
      const element = document.querySelector("hfn-auth");
      if (element && element.handleProfileAuthentication) {
        element.handleProfileAuthentication(status);
      }
    });
  }, []);

  const getProfile = useCallback(
    async (accessInfo) => {
      apiCallCount.current += 1;
      if (apiCallCount.current < 4) {
        try {
          const { getSRCMProfile } = await import("hfnauth/main");
          const resData = await getSRCMProfile({
            srcmBaseURL: `${JSON.parse(config?.mySrcmURL)?.profileServer}/`,
            xClientId: JSON.parse(config?.mySrcmURL)?.xClientId,
            queryParams: ["email", "user_firebase_uid"].join(","),
          });
          if (!resData?.data?.email) {
            toaster.error("Please log in using Email ID!!");
            await logout(false);
            handleAuth(false);
          } else {
            const token = accessInfo?.access_token;
            lStorage.set("logauthInfo", JSON.stringify({ token }));
            lStorage.set("authInfo", { token, isUser: true });
            if (resData?.data) {
              const userInfoData = resData.data;

              if (userInfoData?.user_firebase_uid) {
                const newData = {
                  ...userInfoData,
                  token,
                  srcmToken: token,
                  tokenData: { accessToken: token },
                };

                localStorage.setItem("loadMeData", JSON.stringify(newData));

                try {
                  const loginResponse = await ls.login();
                  const loginResponseData = loginResponse.data;

                  if (!loginResponseData.isError) {
                    await lStorage.set("authInfo", loginResponseData.data);
                    localStorage.setItem("tourRequired", "");
                    localStorage.setItem("tourGuidance", "1");

                    const userRole = getUserRole();
                    const isTourRequiredRole = [
                      "Volunteer",
                      "Zone Coordinator",
                      "State Coordinator",
                      "Trainer",
                      "College Staff",
                      "Campus POC",
                    ].includes(userRole);

                    if (isTourRequiredRole && !cookies.tourRequired) {
                      setCookie("tourRequired", "", { path: "/" });
                      setCookie("tourGuidance", "1", { path: "/" });
                    }

                    if (cookies.tourRequired && cookies.tourGuidance) {
                      localStorage.setItem(
                        "tourRequired",
                        cookies.tourRequired
                      );
                      localStorage.setItem(
                        "tourGuidance",
                        cookies.tourGuidance
                      );
                    }

                    props.dispatch({
                      type: LOGIN,
                      payload: loginResponseData.data,
                    });

                    const { user_type } = loginResponseData.data;
                    handleAuth(true);
                    if (user_type === "T") {
                      history.push("/myprograms");
                    } else {
                      history.push(
                        user_type !== "CS" ? "/dashboard" : "/mycollege"
                      );
                    }
                  } else {
                    const errorMessage =
                      loginResponseData.message?.[0] || "Login failed";
                    if (errorMessage === "User not available") {
                      import("hfnauth/main").then(() => {
                        document
                          .querySelector("hfn-auth")
                          .handleErrorMessage(
                            "You don't have the necessary permissions. Please contact administrator. <br/><br/> <b>Note</b>: On clicking <b>Login with another account</b> you will be logged out from all Heartfulness applications in this browser.",
                            async ({ okClicked }) => {
                              if (okClicked) {
                                handleAuth(true);
                                await logout(false);
                                history.push("/login");
                              }
                            },
                            {
                              showOkBtn: true,
                              showCancel: false,
                              showRetryBtn: false,
                              btnText: "Login with another account",
                            }
                          );
                      });
                    } else {
                      handleAuth(false);
                      toaster.error(errorMessage);
                      lStorage.clear();
                      history.push("/login");
                    }
                  }
                } catch (error) {
                  handleAuth(false);
                  console.error("Login failed:", error);
                  toaster.error("An error occurred during login.");
                }
              } else {
                await getProfile(accessInfo);
              }
            } else {
              handleAuth(false);
            }
          }
        } catch (error) {
          handleAuth(false);
        }
      } else {
        handleAuth(false);
      }
    },
    [handleAuth]
  );
  useEffect(() => {
    import("hfnauth/main").then(() => {
      document.querySelector("hfn-auth").loginCallback = async (res) => {
        try {
          const accessInfo = res?.data;
          if (!accessInfo?.access_token) {
            handleAuth(false);
            return false;
          }
          getProfile(accessInfo);
        } catch {
          handleAuth(false);
        }
        return true;
      };
    });
  }, []);

  return <div />;
}
const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});
export default connect(mapStateToProps)(HFNauth);